import { getKeyToValueMap, getMapToArray } from '@/utils/utils'
// 公共：默认静态文件oss路径
export const OSS_COMMON_PATH = 'https://shendu-oss.sdopen.cn/frondEndFile/mec-chengbei'

/** 上传文件夹 */
export const OSS_DIR = {
  /** 身份证 */
  ID_CARD: 'id_card',
  /** 营业执照 */
  BUSINESS_LICENSE: 'business_license',
  /** 授权委托书 */
  POWER_OF_ATTORNEY: 'power_of_attorney',
  /** 加盟入驻付款截图 */
  OPERATION_UPLOAD_FILE: 'operation_upload_file',
}

/** 文件上传 oss 文件夹名称 */
export const OSS_DIR_NAME = {
  [OSS_DIR.ID_CARD]: '身份证',
  [OSS_DIR.BUSINESS_LICENSE]: '营业执照',
  [OSS_DIR.POWER_OF_ATTORNEY]: '授权委托书',
  [OSS_DIR.OPERATION_UPLOAD_FILE]: '加盟入驻付款截图',
}

// 证件类型枚举
export const ID_TYPE = Object.freeze({
  101: {
    value: 101,
    label: '身份证',
  },
})
export const ID_TYPE_LIST = getMapToArray(ID_TYPE)

// 加盟入驻合作类型
export const JOIN_TYPE_ENUM = Object.freeze({
  CITY_PARTNER: {
    value: 0,
    label: '城市合伙人',
    protocolUrl: `https://shendu-prod.oss-cn-beijing.aliyuncs.com/static/yiyuan/pdf/供票城市合作伙伴合作合同.pdf?v=${new Date().getDate()}`,
  },
  AMBASSADOR: {
    value: 1,
    label: '推广大使',
    protocolUrl: `https://shendu-prod.oss-cn-beijing.aliyuncs.com/static/yiyuan/pdf/供票产品推广大使合作合同.pdf?v=${new Date().getDate()}`,
  },
})
export const JOIN_TYPE_ENUM_MAP = getKeyToValueMap(JOIN_TYPE_ENUM, 'value', 'protocolUrl')
